const moment = require('moment');
// const { fileNotifications: fileNotificationsDummy } = require('@app2/dummyData/notification.js')

/**
 * Export the root Spark application.
 */
module.exports = {

    /**
     * Holds the timestamp for the last time we updated the API token.
     */
    lastRefreshedApiTokenAt: null,


    /**
     * The application's data.
     */
    data() {
      return {
        user: Spark.state.user,
        teams: Spark.state.teams,
        currentTeam: Spark.state.currentTeam,

        loadingNotifications: false,
        notifications: null,

        supportForm: new SparkForm({
          from: '',
          subject: '',
          message: ''
        })
      };
    },


    /**
     * The component has been created by Vue.
     */
    created() {
        var self = this;

        if (Spark.userId) {
            this.loadDataForAuthenticatedUser();
        }

        if (Spark.userId && Spark.usesApi) {
            // this.refreshApiTokenEveryFewMinutes();
        }

        Bus.$on('updateUser', function () {
            self.getUser();
        });

        Bus.$on('updateUserData', function() {
            self.loadDataForAuthenticatedUser();
        });

        Bus.$on('updateTeams', function () {
            self.getTeams();
        });

        Bus.$on('showNotifications', function () {
            self.markNotificationsAsRead();
        });
    },


    /**
     * Prepare the application.
     */
    mounted() {
        this.whenReady();
    },


    methods: {
        /**
         * Finish bootstrapping the application.
         */
        whenReady() {
            //
        },


        /**
         * Load the data for an authenticated user.
         */
        loadDataForAuthenticatedUser() {
            this.getNotifications();
        },


        /**
         * Refresh the current API token every few minutes.
         */
        refreshApiTokenEveryFewMinutes() {
            this.lastRefreshedApiTokenAt = moment();

            setInterval(() => {
                this.refreshApiToken();
            }, 240000);

            setInterval(() => {
                if (moment().diff(this.lastRefreshedApiTokenAt, 'minutes') >= 5) {
                    this.refreshApiToken();
                }
            }, 5000);
        },


        /**
         * Refresh the current API token.
         */
        refreshApiToken() {
            this.lastRefreshedApiTokenAt = moment();

            axios.put('/spark/token');
        },


        /*
         * Get the current user of the application.
         */
        getUser() {
            axios.get('/user/current')
                .then(response => {
                    this.user = response.data;
                    window.Spark.state.user = response.data;
                    if (window.store) {
                      window.store.commit('auth/STORE_USER', response.data);
                      window.store.commit('auth/STORE_TRIAL', response.data.trial);
                    }
                });
        },


        /**
         * Get the current team list.
         */
        getTeams() {
            axios.get('/settings/'+Spark.teamsPrefix)
                .then(response => {
                    this.teams = response.data;
                });
        },


        /**
         * Get the current team.
         */
        getCurrentTeam() {
            return axios.get(`/settings/${Spark.teamsPrefix}/current`)
                .then(response => {
                    this.currentTeam = response.data;
                    window.Spark.state.currentTeam = response.data;
                })
                .catch(response => {
                    //
                });
        },


        /**
         * Get the application notifications.
         */
        getNotifications(params = {}) {
            this.loadingNotifications = true;

            axios.get('/notifications/recent', { params })
                .then(response => {
                    this.notifications = response.data;

                    // this.notifications = {
                    //     notifications: fileNotificationsDummy
                    // }

                    this.loadingNotifications = false;
                });
        },


        /**
         * Mark the current notifications as read.
         */
        markNotificationsAsRead() {
            if (!this.hasUnreadNotifications) {
                return;
            }

            axios.put('/notifications/read', {
                notifications: this.notifications.notifications.map(n => n.id)
            });

          this.notifications.notifications.forEach(notification => {
                notification.read = 1;
            });
        },


        /**
         * Send a customer support request.
         */
        sendSupportRequest() {
            axios.post('/support/email', this.supportForm)
                .then(() => {
                    // $('#modal-support').modal('hide');

                    this.showSupportRequestSuccessMessage();

                    this.supportForm.subject = '';
                    this.supportForm.message = '';
                });
        },


        /**
         * Show an alert informing the user their support request was sent.
         */
        showSupportRequestSuccessMessage() {
            swal({
                title: 'Got It!',
                text: 'We have received your message and will respond soon!',
                type: 'success',
                showConfirmButton: false,
                timer: 2000
            });
        }
    },


    computed: {
        /**
         * The number of unread announcements.
         */
        unreadAnnouncementsCount() {
            if (this.notifications && this.user) {
                if (this.notifications.announcements.length && ! this.user.last_read_announcements_at) {
                    return this.notifications.announcements.length;
                }

                return this.notifications.announcements.filter(announcement => {
                    return moment.utc(this.user.last_read_announcements_at).isBefore(
                        moment.utc(announcement.created_at)
                    );
                }).length;
            }

            return 0;
        },


        /**
         * The number of unread notifications.
         */
        unreadNotificationsCount() {
            if (this.notifications) {
                return this.notifications.notifications.filter(notification => !notification.read).length;
            }

            return 0;
        },


        /**
         * Determine if the user has any unread notifications.
         */
        hasUnreadAnnouncements() {
            return this.unreadAnnouncementsCount > 0;
        },


        /**
         * Determine if the user has any unread notifications.
         */
        hasUnreadNotifications() {
            return this.unreadNotificationsCount > 0;
        }
    }
};
